import React from 'react';
import { render } from 'react-dom';

/* Components */
import CartIcon from './components/CartIcon';
const isMobile = () => window.innerWidth < 1280;

/**
 * Render CartIcon components conditionally based on screen size
 */
const renderCartIcons = () => {
    const cartIconNodes = Array.from(document.querySelectorAll('[data-cart-icon]'));

    if (cartIconNodes.length) {
        cartIconNodes.forEach((node) => {
            const shopwareUrl = node.dataset.shopwareUrl;
            const cartUrl = node.dataset.cartUrl;
            const mobile = node.dataset.mobile;
            const isMobileComponent = mobile === 'true';

            if (isMobileComponent === isMobile()) {
                render(
                    <CartIcon
                        shopwareUrl={shopwareUrl}
                        cartUrl={cartUrl}
                        mobile={mobile}
                    />,
                    node
                );
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', renderCartIcons);
